import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'SearchPipe', pure: true, standalone: true })
export class SearchPipe implements PipeTransform {
  transform(list: any[], searchValue: string): any[] {
    if (!list || !searchValue) {
      return list;
    }
    return list.filter((item) => item?.title.toLowerCase().includes(searchValue.toLowerCase()));
  }
}
